import { Box, Typography, Paper, Grid2 as Grid, Alert, Chip } from "@mui/material";
import { PageHeader } from "@/components/PageHeader";
import { useQuery } from "@tanstack/react-query";
import { diagnosticsApi } from "@/api/diagnostics";
import { errorMessage } from "@/api/client";

function Tile({ label, value, alert }: { label: string; value: number | string; alert?: boolean }) {
  return (
    <Paper sx={{ p: 2, textAlign: "center", borderTop: alert ? "3px solid" : undefined, borderColor: "error.main" }}>
      <Typography variant="h4" fontWeight={600} color={alert ? "error.main" : undefined}>{value}</Typography>
      <Typography variant="caption" color="text.secondary">{label}</Typography>
    </Paper>
  );
}

export function DiagnosticsRadiologyDashboardPage() {
  const q = useQuery({ queryKey: ["dx-rad-dashboard"], queryFn: () => diagnosticsApi.radiologyDashboard(), refetchInterval: 30000 });
  const d = q.data;
  return (
    <Box>
      <PageHeader breadcrumbs={["Diagnostics"]} title="Radiology dashboard" />
      {q.isError && <Alert severity="error" sx={{ mb: 2 }}>{errorMessage(q.error)}</Alert>}
      {d && (
        <Grid container spacing={2}>
          <Grid size={{ xs: 6, md: 4 }}><Tile label="Studies today" value={d.todayStudies} /></Grid>
          <Grid size={{ xs: 6, md: 4 }}><Tile label="Pending reports" value={d.pendingReports} alert={d.pendingReports > 0} /></Grid>
          <Grid size={{ xs: 6, md: 4 }}><Tile label="Active modalities" value={d.activeModalities} /></Grid>
          <Grid size={{ xs: 6, md: 4 }}><Tile label="Critical findings (pending)" value={d.criticalFindingsPending} alert={d.criticalFindingsPending > 0} /></Grid>
          <Grid size={{ xs: 6, md: 4 }}><Tile label="Avg reporting TAT (min)" value={d.avgReportingMinutes} /></Grid>
        </Grid>
      )}
      <Chip size="small" variant="outlined" label="Auto-refreshes every 30s" sx={{ mt: 2 }} />
    </Box>
  );
}
